import auth from './auth'
import driverAuthBearer from './bearer'
import driverHttpAxios from '@websanova/vue-auth/src/drivers/http/axios.1.x.js'
import driverRouterVueRouter from './vue_router'
import driverOAuth2Google from '@websanova/vue-auth/src/drivers/oauth2/google.js'
import driverOAuth2Facebook from '@websanova/vue-auth/src/drivers/oauth2/facebook.js'

driverOAuth2Google.params.client_id = process.env.VUE_APP_API_GOOGLE
driverOAuth2Facebook.params.client_id = process.env.VUE_APP_API_FACEBOOK

export function setupAuth(app, router, axiosInstance) {
  app.use(auth, {
    plugins: {
      http: axiosInstance,
      router: router,
    },
    drivers: {
      auth: driverAuthBearer,
      http: driverHttpAxios,
      router: driverRouterVueRouter,
      oauth2: {
        google: driverOAuth2Google,
        facebook: driverOAuth2Facebook,
      },
    },
    options: {
      rolesKey: 'permissions',
      notFoundRedirect: { path: '/' },
      stores: ['cookie'],
      cookie: {
        Path: '/',
        Domain: null,
        Secure: true,
        Expires: 12096e5,
        SameSite: 'None',
      },
      register: {
        redirect: '/login',
        autoLogin: false,
      },
      fetchData: {
        url: 'auth/me',
      },
      refreshData: {
        url: 'auth/me',
        enabled: false,
      },
      authRedirect: { name: 'Login' },
      auth: {
        redirect: { name: 'Login' },
      },
      oauth2Data: {
        url: 'auth/login/social',
      },
    },
  })
}
